import { createFileRoute, redirect } from '@tanstack/react-router'
import { currentUserQueryOptions } from '@/features/auth/queries'
import { useAuthStore } from '@/stores/auth-store'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'
import { isAuthenticationError } from '@/lib/auth-errors'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    const { auth } = useAuthStore.getState()
    const redirectTarget =
      location.href ??
      `${location.pathname}${location.search ?? ''}${location.hash ?? ''}`

    if (!auth.accessToken) {
      throw redirect({
        to: '/sign-in',
        search: { redirect: redirectTarget },
      })
    }

    try {
      const user = await context.queryClient.ensureQueryData(
        currentUserQueryOptions()
      )
      auth.setUser(user)
    } catch (error) {
      if (isAuthenticationError(error)) {
        auth.reset()
        throw redirect({
          to: '/sign-in',
          search: { redirect: redirectTarget },
        })
      }
    }
  },
  component: AuthenticatedLayout,
})
